/* @flow */
import React, {Component, type Node} from 'react';
import {debounce} from 'lodash';
import type {ListingShape} from '../Hit/Hit';
import {media} from '../../utils/breakpoints';
import type {Breakpoint} from '../../utils/breakpoints';
import type {SearchParamsType} from '../../reducers/searchParams';
import MultiUnitDropdown from '../MultiUnit/MultiUnitDropdown/MultiUnitDropdown';
import MultiUnitModal from '../MultiUnit/MultiUnitModal/MultiUnitModal';
import './MultiUnitProperty.less';

type Props = {
    onMouseEnter?: (listingId: string) => void,
    onMouseLeave?: (listingId: string) => void,
    listing: ListingShape,
    children: Node,
    inputParams: SearchParamsType,
    breakpoint: Breakpoint,
    listingNamespace: string,
    currency: string,
    isMetric: boolean,
    isDatelessSearch: boolean,
    fullLocale: string,
    hitIndex?: number,
    page?: number,
    pageSize?: number,
    mock: string
};

class MultiUnitProperty extends Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    render() {
        const {
            onMouseEnter,
            onMouseLeave,
            listing,
            inputParams,
            breakpoint,
            listingNamespace,
            currency,
            isMetric,
            fullLocale,
            isDatelessSearch,
            mock
        } = this.props;
        const propertyName =
            (listing &&
                listing.propertyMetadata &&
                listing.propertyMetadata.propertyName) ||
            '';
        const handleMouseEnter = () =>
            listing && onMouseEnter ? onMouseEnter(listing.listingId) : null;
        const handleMouseLeave = () =>
            listing && onMouseLeave ? onMouseLeave(listing.listingId) : null;
        const onMouseTimeout = 100;

        const showDesktopView = media(breakpoint, {
            minWidth: 'SM_MIN'
        });
        const multiUnitListing = showDesktopView ? (
            <MultiUnitDropdown
                inputParams={inputParams}
                propertyId={listing && listing.listingNumber}
                systemId={listingNamespace}
                propertyName={propertyName}
                currency={currency}
                isMetric={isMetric}
                fullLocale={fullLocale}
                isDatelessSearch={isDatelessSearch}
                mock={mock}
            />
        ) : (
            <MultiUnitModal
                inputParams={inputParams}
                propertyId={listing && listing.listingNumber}
                systemId={listingNamespace}
                propertyName={propertyName}
                currency={currency}
                isMetric={isMetric}
                fullLocale={fullLocale}
                isDatelessSearch={isDatelessSearch}
                mock={mock}
            />
        );
        return (
            <div
                className="MultiUnitCard"
                role="presentation"
                onMouseEnter={debounce(handleMouseEnter, onMouseTimeout)}
                onMouseLeave={debounce(handleMouseLeave, onMouseTimeout)}
            >
                <div className="MultiUnitCard__header">
                    <div className="MultiUnitCard__header-column MultiUnitCard__header-column--left">
                        <span className="MultiUnitCard__header-text truncated-span">
                            <strong>{propertyName}</strong>
                        </span>
                        {/* TODO Price  Range component */}
                    </div>
                    {multiUnitListing}
                </div>
                {this.props.children}
            </div>
        );
    }
}

export default MultiUnitProperty;
